import { useState, useContext, useEffect } from "react"
import { GlobalContext } from './_app'

import { gql } from "@apollo/client"
import craftApolloClient from "./api/apollo"

import useCustomMediaQuery from "../hooks/useCustomMediaQuery"
import { decodeHtmlEntities } from "../lib/decode-html-entities"

import { Header } from "../fuselage/global/header/header"
import { Footer } from '../fuselage/theme/2024/layout/footer/footer'

import { 
    QueryText, 
    QueryFlipFlops, 
    QueryFloaters, 
    QueryBillboards, 
    QueryBillboardSliders, 
    QueryImpactFigures, 
    QueryVideos,
    QueryForm,
	QueryProfileCarousel,
	QueryImages,
    QuerySEO,
	QueryPartners
} from "../graphql/queries"

import _ from 'lodash'

import Head from 'next/head'
import Image from "next/image"

import handleSeomaticMeta from "../lib/seomatic"

import { PageHero } from "../fuselage/theme/2026/layout/homepage/page-hero/page-hero"


import { HeaderShim } from "../fuselage/global/header/header"
import { About } from '../fuselage/theme/2024/layout/homepage/about'
import { InNumbers } from '../fuselage/theme/2024/layout/homepage/in-numbers'
import { SpeakerCarousel } from '../fuselage/blocks/speaker-carousel/speaker-carousel'
import { SpeakerCard } from '../fuselage/components/speaker-card/speaker-card'
import { ArrowButton } from "../fuselage/components/arrow-button/arrow-button"
import { Quote } from "../fuselage/components/quote/quote"
import { LogoCarousel } from "../fuselage/blocks/logo-carousel/logo-carousel"
import { OffsetCardGrid, SubGrid } from "../fuselage/layout/homepage/offset-cards/offset-cards"
import { VideoGrid } from "../fuselage/layout/homepage/video-grid/video-grid"
import { SponsorGrid } from '../fuselage/theme/2024/layout/homepage/sponsor-grid/sponsor-grid'
import { LogoBoxCarousel } from "../fuselage/components/logo-box-carousel/logo-box-carousel"
import { Button } from "../fuselage/components/button/button"
import { VideoPlayer } from "../fuselage/components/video-player/video-player"

import { PromoGraphic } from "../fuselage/theme/2026/layout/homepage/promo-graphic/promo-graphic"


import { Reveal } from "../fuselage/animation/reveal"
import { Slide, Pop, Fade } from "../fuselage/animation/animation"
import { Podcast } from "../fuselage/components/podcast/podcast"

import CSS from '../css/app/theme-2025.module.css'



const photos = [
	{
        "id": "06",
        "hero": [
            {
                "id": "246832",
                "url": "/assets/img/homepage/gallery-2026/2026-06.jpg",
                "width": 799,
                "height": 543
            }
        ]
    },
    {
        "id": "02",
        "hero": [
            {
                "id": "246832",
                "url": "/assets/img/homepage/gallery-2026/2026-02.jpg",
                "width": 799,
                "height": 543
            }
        ]
    },
    {
        "id": "03",
        "hero": [
            {
                "id": "246832",
                "url": "/assets/img/homepage/gallery-2026/2026-03.jpg",
                "width": 799,
                "height": 543
            }
        ]
    },
	{
        "id": "04",
        "hero": [
            {
                "id": "246832",
                "url": "/assets/img/homepage/gallery-2026/2026-04.jpg",
                "width": 799,
                "height": 543
            }
        ]
	},
	{
        "id": "01",
        "hero": [
            {
                "id": "50183",
                "url": "/assets/img/homepage/gallery-2026/2026-08.jpg",
                "width": 799,
                "height": 543
            }
        ]
    },
	{
        "id": "05",
        "hero": [
            {
                "id": "246832",
                "url": "/assets/img/homepage/gallery-2026/2026-05.jpg",
                "width": 799,
                "height": 543
            }
        ]
    },
	
	{
        "id": "07",
        "hero": [
            {
                "id": "246832",
                "url": "/assets/img/homepage/gallery-2026/2026-07.jpg",
                "width": 799,
                "height": 543
            }
        ]
    },
	{
        "id": "08",
        "hero": [
            {
                "id": "246832",
                "url": "/assets/img/homepage/gallery-2026/2026-01.jpg",
                "width": 799,
                "height": 543
            }
        ]
    },
]

const FeatureCard = ({ iconUrl, heading, children}) => {
	return (
		<section className={`formatted`}>
			<Pop>
				<p><Image src={iconUrl} width={100} height={100} alt="" /></p>
			</Pop>
			<Slide><p className={`fs-4 fw-600 mb-xs`}>{ heading }</p></Slide>
			<Fade>{ children }</Fade>
		</section>
	)
}

const podcastLimit = 4



export default function Home({ entry, sponsorsPage, mediaPage, airlines, speakers }) {

	const globals = useContext(GlobalContext)
	const isDesktop = useCustomMediaQuery('(min-width: 600px)')



	// podcast data fetching

	const [podcasts, setPodcasts] = useState([])
	const [podcastLoading, setPodcastLoading] = useState(true)
	const [error, setError] = useState(false)

	useEffect(() => {
		let active = true

		fetch(`/api/latest-podcasts?limit=${podcastLimit}`)
			.then((response) => {
				if (!response.ok) throw new Error(`Podcast request failed: ${response.status}`)
				return response.json()
			})
			.then((data) => {
				if (active) setPodcasts(data.podcasts || [])
			})
			.catch(() => {
				if (active) setError(true)
			})
			.finally(() => {
				if (active) setPodcastLoading(false)
			})

		return () => {
			active = false
		}
	}, [])



	// video data fetching

	const [videos, setVideos] = useState(null)
	const [videosLoading, setVideosLoading] = useState(true)

	const url = `https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=UCtiJqpefd0Wv0h6YVMZYbGA&maxResults=4&order=date&type=video&key=AIzaSyCLOZc00U47ESr82hC1ZZ-icWqn1sfRaQA`

    useEffect( () => {
		fetch(url, {
			method: "GET"
		})
			.then((res) => res.json())
			.then((result) => {
				setVideos(result)
				setVideosLoading(false)
			})
			.catch((error) => {
				console.error('Error fetching data:', error)
				setVideosLoading(false)
			})
    }, [])








	// console.log('globals:', globals)
	// console.log('entry:', entry)
	// console.log('videos:', videos)
	// console.log('podcasts:', podcasts)
	// console.log('sponsorsPage:', sponsorsPage)
	// console.log('mediaPage:', mediaPage)
	// console.log('airlines:', airlines)
	// console.log('speakers:', speakers)

	// console.log('youtubeVideos:', youtubeVideos)



	// PARTNERS find the partnerGroup content-block
	const allPartners = sponsorsPage.aviadevContentBlocks.find( obj => obj.__typename === 'aviadevContentBlocks_partnerGroups_BlockType' )
	// console.log('partnerGroups:', allPartners.partnerGroups)
	
	// MEDIA PARTNERS find the partnerGroup content-block
	const mediaPartners = mediaPage.aviadevContentBlocks.find( obj => obj.__typename === 'aviadevContentBlocks_partnerGroups_BlockType' )
	// console.log('mediaPartnerGroups:', mediaPartners.partnerGroups)
	

	
	const sectionHeading = `fs-1 c-secondary lh-1 caps`


	return (
		<>
			<Head>
				{ handleSeomaticMeta( entry.seomatic ) }
			</Head>

			<Header mainMenu={globals.nodes} />

			<HeaderShim />


			<PageHero>
				<p className="fs-0 lh-1 c-secondary ff-avian-light">
					Building Connectivity <br />
					<span className="ff-avian-bold c-grad">Realising Ambition</span>
				</p>
				
				{
					!isDesktop &&
					<p className="my-md">
						<Button href={`https://www.eventbooking.uk.com/AVIADEV-2027/`} accent decal={`fs-5 fw-600`} >PURCHASE PASS</Button>
					</p>
				}

				{
					isDesktop &&
					<div className="bt-2 bc-primary my-sm maxw-10"></div>
				}
				

				<p className="fs-4 maxw-35">AviaDev Africa is the premier platform dedicated to enhancing route and fleet development across Sub-Saharan Africa through strategic dialogue and collaboration.</p>
				{/* <p className="mt-sm">
					<ArrowButton href={`https://www.eventbooking.uk.com/aviadev-2026/`} solid theme={{ arrow: `white`, border: `var(--accent)`, label: `var(--primary)`}} >PURCHASE PASS</ArrowButton>
				</p> */}
			</PageHero>



			<About hero={`/assets/img/homepage/about-2026.jpg`}>
				<Reveal>
					<p className={`fs-1 lh-1 c-white caps`}>About AviaDev</p>
				</Reveal>
				<Slide>
					<div className="fw-600 bg-dark formatted mt-sm">
						<p>AviaDev brings together airlines, airports, tourism authorities, and a variety of service providers to drive route and fleet development across the Sub-Saharan African region.</p>
						<p>Through pre-arranged meetings, panel discussions, and targeted networking, AviaDev facilitates the launch of new routes, supports fleet planning decisions, and builds personal and professional partnerships that strengthen intra-African connectivity.</p>
					</div>
				</Slide>
			</About>
			

			
			<PromoGraphic>
				<div className="container formatted">
					<h1 className="c-primary lh-1">AviaDev Finance & Leasing Forum </h1>
					<p>This focused half-day forum is designed to bridge the financing gap for African aviation and catalyse fleet growth and investment.</p>
					<p>Bringing together airlines, lessors, financiers, OEMs, and development finance institutions for a results-oriented programme. Through keynote presentations, real-life case studies, expert panels, and airline investment pitches, it tackles key topics such as:</p>
					<ul className="fw-500 c-primary">
						<li>Fleet financing strategies</li>
						<li>Aircraft leasing structures</li>
						<li>Managing credit risk in African markets</li>
						<li>Accessing and structuring capital for growth</li>
					</ul>
					<p>Whether your goal is to finance aircraft, understand regional risk, or meet qualified airline prospects, this is the platform where aviation finance and opportunity converge * Included in your AviaDev ticket.</p>

					<p className="mt-sm"><Button href="/aviadev-finance-and-leasing-forum" decal={`fw-600`}>More Info</Button></p>
				</div>
			</PromoGraphic>

			

            {/* overview + impact */}

            <InNumbers />


			
			{/* sponsor logos */}
			
			{
				allPartners.partnerGroups.length &&
				<SponsorGrid>
					{
						allPartners.partnerGroups.map( group => (
							<LogoBoxCarousel
								key={group.id}
								heading={group.title} 
								sponsors={group.partners} 
							/>
						))
					}
					{
						mediaPartners.partnerGroups.map( group => (
							<LogoBoxCarousel
								key={group.id}
								heading={group.title} 
								sponsors={group.partners} 
							/>
						))
					}
				</SponsorGrid>
			}

			

			{/* airlines */}

			<section className="block bg-wash">
				<div className="container">
					<LogoCarousel 
						sponsors={airlines.partners} 
						heading={'2026 AIRLINE ATTENDEES'} 
					/>
				</div>
			</section>


			{/* speakers */}

			<SpeakerCarousel
				heading={`Speaker Highlights`}
				text={`Members of our speaking faculty are chosen for their industry knowledge, experience and the insight they offer to progress African aviation.`}
				ctaLink={`/speakers`}
				ctaLabel={`See all speakers`}
				decal={`bg-primary`}
			>
				{
					speakers &&
					speakers.map( speaker => {
						if ( speaker.hidden ) return
						return (
							<Pop key={speaker.id}>
								<SpeakerCard
									key={speaker.id}
									url={`/speakers/profile/${speaker.slug}`}
									photoUrl={speaker.avatar.length ? speaker.avatar[0].url : null}
									fullName={speaker.title}
									jobTitle={speaker.positions[0].jobTitle}
									company={speaker.positions[0].organisation}
								/>
							</Pop>
						)
					})
				}
				
			</SpeakerCarousel>


			{/* feature cards */}

			<section className="block bg-dark" style={{ overflow: `hidden` }}>
				
				
				<div className="container columns-5 gap-sm">
					
					<FeatureCard heading={`Airports / CAAs`} iconUrl={`/assets/img/homepage/icon-airports.svg`}>
						<p>Attend AviaDev as a delegate (with or without pre-scheduled meetings) or as an exhibitor, complete with your own branded meeting stand to showcase your airport and destination.</p>
						<p>AviaDev is an opportunity to connect with multiple airlines in one place, build valuable new relationships, and increase capacity through new and existing routes.</p>
					</FeatureCard>

					<FeatureCard heading={`Airlines`} iconUrl={`/assets/img/homepage/icon-airlines.svg`}>
						<p>Qualifying airlines can attend free of charge.</p>
						<p>Take part in high-level route development meetings with new and existing airports and airline partners, aimed at expanding and strengthening your network.</p>
						<p className="pb-md">Engage in lively discussions and gain valuable knowledge through our interactive workshops and comprehensive conference programme.</p>
					</FeatureCard>
				
					<FeatureCard heading={`Service Providers`} iconUrl={`/assets/img/homepage/icon-suppliers.svg`}>
						<p>Relevant industry service providers can choose to attend as a sponsor with 8 pre-arranged meetings with key decision-makers. Alternatively, join as a delegate and enjoy full access to every element of the conference.</p>
						<p>Connect with potential partners to showcase your products and services to the African aviation community.</p>
					</FeatureCard>
				
					<FeatureCard heading={`Financiers / Banks`} iconUrl={`/assets/img/homepage/icon-finance.svg`}>
					<p>Corporate banks, development banks, export-credit agencies and other aviation finance institutions can connect with airlines and key decision-makers from across the African aviation market.</p>
					<p>Engage directly with qualified airline prospects, lessors, OEMs to identify new opportunities, structure and provide finance for aircraft acquisition, fleet growth and expansion.</p>
					</FeatureCard>

					<FeatureCard heading={`Tourism Authorities`} iconUrl={`/assets/img/homepage/icon-tourism.svg`}>
						<p>Tourism authorities are invited to join and work alongside their airports in the mission to attract new air services.</p>
						<p>Showcase your destination and encourage more visitors to your region.</p>
					</FeatureCard>
					
				</div>
			</section>


		

			{/* highlights video */}

			<VideoGrid videoUrl={`https://youtu.be/-udQ7tCDJtc`}>
				<div className={`${sectionHeading} c-white`}>
					<Reveal>AVIADEV 2026 VIDEO HIGHLIGHTS</Reveal>
				</div>
			</VideoGrid>


			{/* quote */}

			<section className="block bg-green" >
				<div className="container">
					<Quote 
						avatar={{ url: 'https://cms.thebench.com/assets/img/avatars/Martin.jpg' }}
						quote={`Africa's leading aviation connectivity platform, bringing together airlines, airports, tourism stakeholders, and industry leaders to accelerate sustainable route development and strengthen the continent's air connectivity.`} 
						name={`Martin Gitonga`} 
						title={`Kenya Airways`}
						decal={`c-white fs-2 caps`}
					/>
				</div>
			</section>


			{/* highlights video */}

			{/* <VideoGrid videoUrl={`https://youtu.be/x01py8hA8BY`} decal={'bg-dark'}>
				<div className={`${sectionHeading} c-white`}>
					<Reveal>Finance and Leasing Forum Highlights </Reveal>
				</div>
			</VideoGrid> */}


			
			{/* youtube videos live feed */}

			<section className="block bg-primary">
				<div className="container center">
					<p className='fs-1 fw-600'>Latest Videos</p>
				</div>
				<div className="container columns-2 gap-sm">
					{
						videosLoading && <p>Loading...</p>
					}
					{/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
					{
						videos &&
						videos.items.map((video, index) => {
							return (
								<Pop key={index}>
									<div>
										<VideoPlayer videoUrl={`https://www.youtube.com/watch?v=${video.id.videoId}}`} />
										<p className="fw-500 fs-5 c-white lh-2 mt-xs">{ decodeHtmlEntities(video.snippet.title) }</p>
									</div>
								</Pop>
							)
						})
					}
                </div>
            </section>
			

			{/* podcasts live feed */}
			
			<section className="block bg-medium">
				<div className="container center">
					<p className='fs-1 fw-600'>Latest Podcasts</p>
				</div>
				<div className="container columns-2 gap-sm">
					{podcastLoading ? <p>Loading podcasts...</p> : error ? <p>Unable to load podcasts right now.</p> : podcasts.length ? podcasts.map((podcast, i) => (
							
							<Podcast key={i} data={podcast} />

						)) : <p>No podcasts are available right now.</p>}
				</div>
			</section>




			{/* photos */}

			<section className="block bg-green" style={{ overflow: `hidden` }}>
				<div className={`${CSS.photoGrid} container`}>
                    <Slide><p className='fs-0 fw-700 lh-1'>2026 in Photos</p></Slide>
                    
                    <div className="columns-3 gap-xs mt-md">
                        {
                            photos.map( (photo, index) => (
                                <Pop key={index}>
                                    <div key={photo.id} style={{ position: `relative`}}>
                                        <Image src={photo.hero[0].url} width={photo.hero[0].width} height={photo.hero[0].height} layout={`responsive`} alt="" />
                                    </div>
                                </Pop>
                            ))
                        }
                        <p className="p-xs">
                            <ArrowButton href={`https://www.flickr.com/photos/benchevents/albums/72177720334200921`} target='_blank' theme={{ arrow: `white`, border: `white`, label: `white`}}>View all photos</ArrowButton>
                        </p>
                    </div>

                </div>
			</section>

			
			{/* quotes */}

			<div className="block">
				<div className="container columns-2 gap-md">
					<div>
						<Quote 
							avatar={{ url: 'https://cms.thebench.com/assets/img/avatars/Mark-W-Photo.jpg' }}
							quote={`Excellent couple of days with genuinely engaging conference content, and effective in-person meetings.`} 
							name={`Mark Wilkinson`} 
							title={`Cape Winelands Airport`}
							decal={`c-primary fs-2 caps`}
						/>
					</div>
					<div>
						<Quote 
							avatar={{ url: 'https://cms.thebench.com/assets/img/avatars/zoe_2024-01-15-112543_tpxa.jpg' }}
							quote={`The best forum for aviation industry in Africa!`} 
							name={`Zoe Rajohnson`} 
							title={`Ravinala Airports`}
							decal={`c-primary fs-2 caps`}
						/>
					</div>
				</div>
			</div>



			<Footer 
				socialConnections={globals.globalSets[2].socialConnections} 
				contactInfo={globals.globalSets[2].contactDetails[0].body}
				hubspotForm={globals.globalSets[2].hubspotForm[0] ? globals.globalSets[2].hubspotForm[0] : null}
			/>
			
		</>
	)
}
Home.theme = 'aviadev-2024'





export async function getStaticProps({ preview, previewData }) {

    const data = await craftApolloClient( preview, previewData ).query({
        query: gql`
			query Homepage {
				entry(site: "${process.env.SITE_HANDLE}", id: "40870") {
					id
					title
					... on ${process.env.SITE_HANDLE}Homepage_${process.env.SITE_HANDLE}Homepage_Entry {
						${process.env.SITE_HANDLE}ContentBlocks {
							${QueryText}
                            ${QueryFlipFlops}
                            ${QueryFloaters}
                            ${QueryBillboards}
                            ${QueryBillboardSliders}
                            ${QueryImpactFigures}
                            ${QueryVideos}
                            ${QueryProfileCarousel}
                            ${QueryForm}
                            ${QueryImages}
						}
						${QuerySEO}
					}
				}
			}
        `
    })
    const pageData = data
    

	// sponsors from cms
	const sponsorData = await craftApolloClient().query({
        query: gql`
			query Page {
				entry(site: "${process.env.SITE_HANDLE}", id: "54163") {
					... on ${process.env.SITE_HANDLE}Partners_${process.env.SITE_HANDLE}Partners_Entry {
						id
						${process.env.SITE_HANDLE}ContentBlocks {
							${QueryPartners}
						}
					}
				}
			}
        `
    })

	// media partners from cms
	const mediaPartnerData = await craftApolloClient().query({
        query: gql`
			query Page {
				entry(site: "${process.env.SITE_HANDLE}", id: "54130") {
					... on ${process.env.SITE_HANDLE}Pages_page_Entry {
						id
						${process.env.SITE_HANDLE}ContentBlocks {
							${QueryPartners}
						}
					}
				}
			}
        `
    })
	
	// selected speakers from cms
	const speakersData = await craftApolloClient().query({
        query: gql`
			query Speakers {
				entries(
					site: "${process.env.SITE_HANDLE}", 
					section: "profiles", 
					id: [ 
						304110,
						177749,
						249343,
						304115,
						185550,
						219546,
						304140,
						304130,
						200149,
						304120
					],
					fixedOrder: true
				) {
					... on profiles_profile_Entry {
                        id
                        slug
                        title
                        avatar {
                            ... on avatars_Asset {
                                id
                                url
                                width
                                height
                            }
                        }
                        positions {
                            ... on positions_BlockType {
                                id
                                jobTitle
                                organisation
                            }
                        }
                        profile
                    }
				}
			}
        `
    })
	
	
	// airlines from cms
	const airlinesData = await craftApolloClient().query({
        query: gql`
			query PartnerGroupEntry {
				entry(site: "${process.env.SITE_HANDLE}", section: "partnerGroups", id: 277882) {
					... on partnerGroups_default_Entry {
						id
						partners {
							... on partners_partner_Entry {
								id
								title
								partnerLogo {
									url
									width
									height
								}
							}
						}
					}
				}
			}
        `
    })


	// content-library

	const videoQuery = await craftApolloClient( preview, previewData ).query({
        query: gql`
			query Videos {
				entries(site: "${process.env.SITE_HANDLE}", section: "contentLibrary", relatedTo: "7704", limit: 3) {
					... on contentLibrary_article_Entry {
						id
						slug
						title
						postDate
						excerpt
						contentLibraryHero {
							id
							url
							width
							height
						}
						contentTypes {
							... on contentLibrary_Category {
								id
								title
								slug
							}
						}
					}
				}
			}
        `
    })
    const videoData = videoQuery
    
	const podcastQuery = await craftApolloClient( preview, previewData ).query({
        query: gql`
			query Podcasts {
				entries(site: "${process.env.SITE_HANDLE}", section: "contentLibrary", relatedTo: "7701", limit: 3) {
					... on contentLibrary_article_Entry {
						id
						slug
						title
						postDate
						excerpt
						contentLibraryHero {
							id
							url
							width
							height
						}
						contentTypes {
							... on contentLibrary_Category {
								id
								title
								slug
							}
						}
					}
				}
			}
        `
    })
	const podcastData = podcastQuery
	


    return { 
		props: { 
			entry: pageData.data.entry,
			videos: videoData.data.entries,
			podcasts: podcastData.data.entries,
			sponsorsPage: sponsorData.data.entry,
			mediaPage: mediaPartnerData.data.entry,
			airlines: airlinesData.data.entry,
			speakers: speakersData.data.entries,
		}
	}
}


